import { Empty } from "antd";
import { formatDateFunction } from "../../utils/helper/utils";
import toast from "react-hot-toast";

const copyText = async (textToCopy, e) => {
  e.stopPropagation();
  try {
    await navigator.clipboard.writeText(textToCopy);
    toast.success("Copied to clipboard!");
  } catch (err) {
    toast.error("Failed to copy text");
  }
};

const CannedOrderListing = ({ handleOrderDetail, list, selectedId }) => {
  return (
    <>
      {list && list.length > 0 ? (
        list.map((item, index) => {
          return (
            <div
              key={index}
              className={`border-gray-250 border-b p-3 cursor-pointer hover:bg-gray-50 ${
                selectedId === item.id ? "bg-blue-50 border-l-4 border-l-primary" : ""
              }`}
              onClick={() => {
                handleOrderDetail(item.id);
              }}
            >
              <div className="flex justify-between items-center gap-1 mb-2">
                <div className="font-bold text-[12px] whitespace-nowrap">
                  <span
                    onClick={(e) => copyText(item?.cannedOrderNumber, e)}
                    className="cursor-pointer hover:underline"
                    title="Click to copy order number"
                  >
                    #{item?.cannedOrderNumber}
                  </span>
                </div>
                <div>
                  <span className={`px-2 py-1 rounded-md text-[10px] whitespace-nowrap ${
                    item.status === 'ready_to_ship' || item.status === 'ready-to-ship' 
                    ? 'bg-blue-100 text-blue-700' 
                    : 'bg-green-100 text-green-700'
                  }`}>
                    {item.status === 'ready_to_ship' || item.status === 'ready-to-ship' ? 'Ready to Ship' : 'Delivered'}
                  </span>
                </div>
              </div>
              
              <div className="text-sm font-semibold mb-1">
                {item.customerDetails?.name || `${item.customer?.firstName} ${item.customer?.lastName}`}
              </div>
              
              <div className="text-[12px] text-gray-500 mb-2">
                {item.machine?.name}
              </div>

              <div className="flex justify-between items-end">
                <div className="text-sm font-bold text-primary">
                  SAR {item.totalAmount}
                </div>
                <div className="text-[11px] text-gray-400">
                  {formatDateFunction(item.createdAt, "dd/mm/yyyy", true)}
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="flex-auto pt-5 min-h-[300px] flex items-center justify-center">
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Orders Available" />
        </div>
      )}
    </>
  );
};

export default CannedOrderListing;
